function createCaseClick() {}

export const tabsCreateCase = [
  {
    label: "Policy Number",
  },
  {
    label: "Claim Number",
  },
  {
    label: "Email ID",
  },
  {
    label: "Customer Mobile No",
  },
];

export const tabs2CreateCase = [
  {
    label: "Basic Details",
    key: "basic",
  },
  {
    label: "Claim details",
    key: "claim",
  },
  {
    label: "Endorsement Details",
    key: "endorsement",
  },
  // {
  //   label: "CHASE Smart",
  // },
  {
    label: "Policy Details",
    key: "policy",
  },
  {
    label: "Proposal Details",
    key: "proposal",
  },
  // {
  //   label: "Dispatch Details",
  // },
  {
    label: "Risk Details",
    key: "risk",
  },
];

export const CreateCaseTableGrid = [
  {
    label: "Basic Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Policy Start Date",
        value: "last week",
      },
      {
        label: "Policy Status",
        value: "Active",
      },
      {
        label: "Claim Number",
        value: "CASE/879/797",
      },
      {
        label: "Policy End Date",
        value: "last week",
      },
      {
        label: "Policy Issue Date",
        value: "last week",
      },
    ],
  },
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
        headerPaddingLeft: "12px",
      },
      {
        id: "claim_reference_no",
        label: "Claim Number:",
        align: "left",
      },
      {
        id: "loss_date",
        label: "Loss Date:",
        align: "left",
      },
      {
        id: "registration_date",
        label: "Registration Date:",
        align: "left",
      },
      {
        id: "claim_registered_by",
        label: "Claim Registered By:",
        align: "left",
      },
      {
        id: "view_details",
        label: " ",
        align: "right",
        color: "#1395CC",
        cursor: "pointer",
      },
      {
        id: "create_case",
        fontSize: " ",
        align: "left",
        color: "#1395CC",
        cursor: "pointer",
        onClick: createCaseClick,
      },
    ],
  },
  {
    label: "Endorsement Details",
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
        headerPaddingLeft: "12px",
      },
      {
        id: "endorsement_no",
        label: "Endorsement No:",
        align: "left",
      },
      {
        id: "type_of_endorsement",
        label: "Type Of Endorsement:",
        align: "left",
      },
      {
        id: "transaction_date",
        label: "Transaction Date:",
        align: "left",
      },
      {
        id: "premium_amt",
        label: "Premium Amt:",
        align: "left",
      },
      {
        id: "view_details",
        label: " ",
        align: "left",
        color: "#1395CC",
        cursor: "pointer",
      },
    ],
  },
  {
    row: [
      {
        srNo: "1",
        dispatchDate: "case/2022-10-13/55113",
        deliveryDate: "last week",
        dispatchType: "Active",
        firstReturnDate: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "2",
        dispatchDate: "case/2022-10-13/55113",
        deliveryDate: "last week",
        dispatchType: "Active",
        firstReturnDate: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "3",
        dispatchDate: "case/2022-10-13/55113",
        deliveryDate: "last week",
        dispatchType: "Active",
        firstReturnDate: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "4",
        dispatchDate: "case/2022-10-13/55113",
        deliveryDate: "last week",
        dispatchType: "Active",
        firstReturnDate: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "5",
        dispatchDate: "case/2022-10-13/55113",
        deliveryDate: "last week",
        dispatchType: "Active",
        firstReturnDate: "CASE/879/797",
        blank: "View Details",
      },
    ],
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "dispatchDate",
        label: "Dispatch Date:",
        align: "left",
      },
      {
        id: "deliveryDate",
        label: "Delivery Date:",
        align: "left",
      },
      {
        id: "dispatchType",
        label: "Dispatch Type:",
        align: "left",
      },
      {
        id: "firstReturnDate",
        label: "First Return Date:",
        align: "left",
      },
      {
        id: "blank",
        label: " ",
        align: "left",
        color: "#1395CC",
        cursor: "pointer",
      },
    ],
    tableGridVal: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    row: [
      {
        srNo: "1",
        claim_number: "case/2022-10-13/55113",
        lossDate: "last week",
        registrationDate: "Active",
        claimRegisteredBy: "CASE/879/797",
        blank: "View Details",
        blank2: "Create Case",
      },
      {
        srNo: "2",
        claim_number: "case/2022-10-13/55113",
        lossDate: "last week",
        registrationDate: "Active",
        claimRegisteredBy: "CASE/879/797",
        blank: "View Details",
        blank2: "Create Case",
      },
      {
        srNo: "3",
        claim_number: "case/2022-10-13/55113",
        lossDate: "last week",
        registrationDate: "Active",
        claimRegisteredBy: "CASE/879/797",
        blank: "View Details",
        blank2: "Create Case",
      },
      {
        srNo: "4",
        claim_number: "case/2022-10-13/55113",
        lossDate: "last week",
        registrationDate: "Active",
        claimRegisteredBy: "CASE/879/797",
        blank: "View Details",
        blank2: "Create Case",
      },
      {
        srNo: "5",
        claim_number: "case/2022-10-13/55113",
        lossDate: "last week",
        registrationDate: "Active",
        claimRegisteredBy: "CASE/879/797",
        blank: "View Details",
        blank2: "Create Case",
      },
    ],
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "claim_number",
        label: "Claim_Number:",
        align: "left",
      },
      {
        id: "lossDate",
        label: "Loss Date:",
        align: "left",
      },
      {
        id: "registrationDate",
        label: "Registration Date:",
        align: "left",
      },
      {
        id: "claimRegisteredBy",
        label: "Claim Registered By:",
        align: "left",
      },
      {
        id: "blank",
        label: " ",
        align: "right",
        color: "#1395CC",
        cursor: "pointer",
      },
      {
        id: "blank2",
        fontSize: " ",
        align: "left",
        color: "#1395CC",
        cursor: "pointer",
        onClick: createCaseClick,
      },
    ],
    tableGridVal: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Risk Details",
    tabComponent: [
      {
        label: "Deductible",
        value: "case/2022-10-13/55113",
      },
      {
        label: "RTO Location",
        value: "last week",
      },
      {
        label: "Seating Capacity",
        value: "Active",
      },
      {
        label: "Vehicle  Model – Variant",
        value: "CASE/879/797",
      },
      {
        label: "Manufacturing Year",
        value: "last week",
      },
      {
        label: "CC Capacity",
        value: "last week",
      },
      {
        label: "Vehicle Make",
        value: "case/2022-10-13/55113",
      },
      {
        label: "IDV",
        value: "last week",
      },
      {
        label: "Name of Proposer",
        value: "Active",
      },
      {
        label: "Customer Name",
        value: "CASE/879/797",
      },
      {
        label: "Name of All Insured",
        value: "last week",
      },
      {
        label: "Type of Insured",
        value: "last week",
      },
      {
        label: "Relationship",
        value: "case/2022-10-13/55113",
      },
      {
        label: "DOB",
        value: "last week",
      },
      {
        label: "Sum Insured",
        value: "Active",
      },
      {
        label: "Coverage  Name",
        value: "CASE/879/797",
      },
      {
        label: "Vehicle Chasis No",
        value: "last week",
      },
      {
        label: "Registration Date",
        value: "last week",
      },
    ],
  },
  {
    row: [
      {
        srNo: "1",
        endorsementNo: "case/2022-10-13/55113",
        typeOfEndorsement: "last week",
        transactionDate: "Active",
        premiumAmt: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "2",
        endorsementNo: "case/2022-10-13/55113",
        typeOfEndorsement: "last week",
        transactionDate: "Active",
        premiumAmt: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "3",
        endorsementNo: "case/2022-10-13/55113",
        typeOfEndorsement: "last week",
        transactionDate: "Active",
        premiumAmt: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "4",
        endorsementNo: "case/2022-10-13/55113",
        typeOfEndorsement: "last week",
        transactionDate: "Active",
        premiumAmt: "CASE/879/797",
        blank: "View Details",
      },
      {
        srNo: "5",
        endorsementNo: "case/2022-10-13/55113",
        typeOfEndorsement: "last week",
        transactionDate: "Active",
        premiumAmt: "CASE/879/797",
        blank: "View Details",
      },
    ],
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "endorsementNo",
        label: "Endorsement No:",
        align: "left",
      },
      {
        id: "typeOfEndorsement",
        label: "Type Of Endorsement:",
        align: "left",
      },
      {
        id: "transactionDate",
        label: "Transaction Date:",
        align: "left",
      },
      {
        id: "premiumAmt",
        label: "Premium Amt:",
        align: "left",
      },
      {
        id: "blank",
        label: " ",
        align: "left",
        color: "#1395CC",
        cursor: "pointer",
      },
    ],
    tableGridVal: [
      {
        label: "Premium _ Non-premium bearing",
        value: "last week",
      },
      {
        label: "Endorsement Reason",
        value: "last week",
      },
    ],
  },
  {
    label: "CHASE Smart",
    isDocuments: true,
    documentDetails: [
      {
        name: "CIBIL Report.pdf",
        size: "2.4kb",
      },
    ],
    tabComponent: [
      {
        label: "Driver Extract & Validity",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Type of Licence",
        value: "last week",
      },
      {
        label: "DL Verification",
        value: "Active",
      },
      {
        label: "RC Ver. Permit Verification",
        value: "CASE/879/797",
      },
      {
        label: "Fitness Verification",
        value: "last week",
      },
      {
        label: "Insurance Details & Validity of Insurance",
        value: "last week",
      },
      {
        label: "Company Name",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Policy Number",
        value: "last week",
      },
      {
        label: "Category",
        value: "Active",
      },
      {
        label: "Pan Verification",
        value: "CASE/879/797",
      },
      {
        label: "Blacklist Status",
        value: "last week",
      },
      {
        label: "ITR Validation",
        value: "last week",
      },
      {
        label: "Customer PAN Number",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Phone Number",
        value: "last week",
      },
      {
        label: "Customer Full Name",
        value: "Active",
      },
      {
        label: "Address",
        value: "CASE/879/797",
      },
      {
        label: "Voter ID",
        value: "last week",
      },
      {
        label: "CRIF Report",
        value: "last week",
      },
      {
        label: "CB Amount",
        value: "last week",
      },
      {
        label: "Trace Lost Vehicle",
        value: "Active",
      },
      {
        label: "Flag in CIMA",
        value: "CASE/879/797",
      },
    ],
  },
];

export const CreateCaseMainTableData = [
  {
    column: [
      // {
      //   id: "srNo",
      //   label: "Sr. No",
      //   align: "left",
      // },
      {
        id: "claim_xgen_number",
        label: "Case No.",
        align: "left",
        color: "red",
        minWidth: "10rem",
        cursor: "pointer",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      // {
      //   id: "case_created_by",
      //   label: "Case Created By",
      //   align: "left",
      // },

      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "lob_id",
        label: "LOB",
        align: "left",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "left",
      },
      // {
      //   id: "assigned_date",
      //   label: "Assigned Date",
      //   align: "left",
      // },
      {
        id: "registration_date",
        label: "Reg Date",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 5,
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 6,
        policy_number: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 7,
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 8,

        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 9,

        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
    ],
  },
  //2
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },

      {
        id: "claimNo",
        label: "Claim No.",
        align: "left",
      },

      {
        id: "policyNo",
        label: "Policy No.",
        align: "left",
        color: "red",

        minWidth: "10rem",
        cursor: "pointer",
      },

      {
        id: "customerNo",
        label: "Customer No.",
        align: "left",
      },

      {
        id: "product",
        label: "Product",
        align: "left",
      },
      {
        id: "issueDate",
        label: "Issue Date",
        align: "left",
      },
      {
        id: "startDate",
        label: "Start Date",
        align: "left",
      },
      {
        id: "endDate",
        label: "End Date",
        align: "left",
      },
      {
        id: "policyStatus",
        label: "Policy Status",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 1,
        claimNo: "C2300333 54669",
        policyNo: "2300222546 6900000001",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
    ],
  },
  //3
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },

      {
        id: "emailID",
        label: "Email ID",
        align: "left",
      },

      {
        id: "policyNo",
        label: "Policy No.",
        align: "left",
        color: "red",

        minWidth: "10rem",
        cursor: "pointer",
      },

      {
        id: "customerNo",
        label: "Customer No.",
        align: "left",
      },

      {
        id: "product",
        label: "Product",
        align: "left",
      },
      {
        id: "issueDate",
        label: "Issue Date",
        align: "left",
      },
      {
        id: "startDate",
        label: "Start Date",
        align: "left",
      },
      {
        id: "endDate",
        label: "End Date",
        align: "left",
      },
      {
        id: "policyStatus",
        label: "Policy Status",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 5,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 6,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 7,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 8,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 9,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
    ],
  },
  {
    //4
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },

      {
        id: "emailID",
        label: "Email ID",
        align: "left",
      },

      {
        id: "policyNo",
        label: "Policy No.",
        align: "left",
        color: "red",
        minWidth: "10rem",
        cursor: "pointer",
      },

      {
        id: "customerNo",
        label: "Customer No.",
        align: "left",
      },

      {
        id: "product",
        label: "Product",
        align: "left",
      },
      {
        id: "issueDate",
        label: "Issue Date",
        align: "left",
      },
      {
        id: "startDate",
        label: "Start Date",
        align: "left",
      },
      {
        id: "endDate",
        label: "End Date",
        align: "left",
      },
      {
        id: "policyStatus",
        label: "Policy Status",
        align: "left",
      },
    ],

    row: [
      {
        srNo: 5,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 6,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 7,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 8,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
      {
        srNo: 9,
        emailID: "paramesh@gmail.com",
        policyNo: "C2300222 54669",
        customerNo: "+91 9311407317",
        product: "Motor",
        issueDate: "02/10/2022",
        startDate: "02/10/2022",
        endDate: "02/10/2022",
        policyStatus: "-",
      },
    ],
  },
];
